var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import {
  memo,
  startTransition,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState
} from "react";
import { Input, Layout, Menu, Flex, theme, Grid, Drawer } from "antd";
import LeftTreeApi from "./../../api/LeftTreeApi.js";
import { ReactComponent as Search } from "./../../assets/icons/search.svg";
import { Outlet, useNavigate, useLocation, useParams } from "react-router-dom";
import Loader from "./../loader/Loader.js";
import { EVENT_ACTIONS, track } from "./../../lib/gtag.js";
import useBurgerMenu from "./../../hook/useBurgerMenu.js";
import { filterMenu, mapDataToMenuItems } from "./appLayoutService";
const { Content, Sider } = Layout;
const { useBreakpoint } = Grid;
const SIDEBAR_OFFSET = 24;
const AppLayout = ({
  showSelectLanguage = true,
  headerHeight,
  drawerOpened,
  setDrawerOpened,
  burgerMenuItems = [],
  hideSideBars = false,
  containerClassName = "",
  rightSidebar = null
}) => {
  const [items, setItems] = useState([]);
  const [openKeys, setOpenKeys] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [term, setTerm] = useState("");
  const { items: additionalItems } = useBurgerMenu({
    menuItems: burgerMenuItems,
    showSelectLanguage
  });
  const menuRef = useRef(null);
  const { token } = theme.useToken();
  const navigate = useNavigate();
  const getLeftTreeDataApi = LeftTreeApi.getLeftTreeData();
  const location = useLocation();
  const { id } = useParams();
  const pathnameFirstSegment = location.pathname.split("/")[1];
  const hideMenuSidebar = ["contact-us"].includes(pathnameFirstSegment) || hideSideBars;
  const screens = useBreakpoint();
  const showMenuSidebar = screens.lg && !hideMenuSidebar;
  const toggleDrawer = () => setDrawerOpened(!drawerOpened);
  const getLeftTreeData = useCallback(async () => {
    var _a;
    try {
      const response = await getLeftTreeDataApi.call();
      const menuItems = mapDataToMenuItems({
        children: (_a = response.data.children) != null ? _a : []
      });
      setItems(menuItems);
      setOpenKeys(menuItems.map((item) => item.key));
    } catch (error) {
      console.error("Error fetching left tree data:", error);
    }
  }, [getLeftTreeDataApi]);
  useEffect(() => {
    var _a;
    if (pathnameFirstSegment !== "league") {
      setSelectedKeys([]);
    } else {
      const selectedItemByUrl = (_a = menuRef.current) == null ? void 0 : _a.menu.list.querySelector(
        `[id="${id}"]`
      );
      if (selectedItemByUrl) {
        setSelectedKeys([selectedItemByUrl.dataset.key]);
      }
    }
  }, [location.pathname, items]);
  useEffect(() => {
    getLeftTreeData();
    return () => {
      getLeftTreeDataApi.cancel();
    };
  }, []);
  useEffect(() => {
    document.body.style.overflowY = drawerOpened ? "hidden" : "auto";
    return () => {
      document.body.style.overflowY = "auto";
    };
  }, [drawerOpened]);
  const handleMenuSelect = (selected) => {
    var _a;
    if ((_a = selected.key) == null ? void 0 : _a.includes("disable-redirection")) {
      return;
    }
    setSelectedKeys([selected.key]);
    track(EVENT_ACTIONS.LEAGUE_DETAILS_FROM_LEAGUES);
    navigate(`/league/${selected.item.props.id}`);
  };
  const handleTermChange = (e) => {
    startTransition(() => setTerm(e.target.value));
  };
  const filteredItems = useMemo(() => filterMenu(items, term), [items, term]);
  const mobileMenuItems = useMemo(() => {
    return [
      ...additionalItems,
      // tbd: hidden search input for mobile, will be added later
      // {
      //     label: (
      //         <div className="search-wrapper">
      //             <Input
      //                 prefix={<Search className="stroke-base" />}
      //                 onChange={handleTermChange}
      //                 allowClear
      //             />
      //         </div>
      //     ),
      //     key: 'search-input disable-redirection',
      // },
      ...filteredItems
    ];
  }, [filteredItems, additionalItems]);
  return !items.length ? /* @__PURE__ */ jsx(Loader, {}) : /* @__PURE__ */ jsx(
    Layout,
    {
      style: __spreadValues({
        padding: "0 0 24px",
        gap: 24
      }, showMenuSidebar && {
        padding: 0,
        margin: `-${SIDEBAR_OFFSET}px 0 0 -${SIDEBAR_OFFSET}px`
      }),
      children: /* @__PURE__ */ jsxs(Flex, { gap: 24, style: { width: "100%" }, children: [
        !screens.lg && /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
          Drawer,
          {
            title: null,
            placement: "left",
            onClose: toggleDrawer,
            open: drawerOpened,
            closable: false,
            width: "100%",
            styles: {
              wrapper: {
                bottom: "env(safe-area-inset-bottom, 0)"
              },
              content: {
                background: token.colorBgBase
              },
              mask: {
                background: "transparent"
              },
              body: {
                backgroundColor: token.colorBgContainer,
                marginTop: !screens.lg ? headerHeight + 1 : 204,
                borderRadius: 0,
                padding: "4px 0"
              }
            },
            children: mobileMenuItems.length ? /* @__PURE__ */ jsx(
              Menu,
              {
                ref: menuRef,
                className: "left-tree-menu",
                mode: "inline",
                defaultOpenKeys: openKeys,
                selectedKeys,
                items: mobileMenuItems,
                onClick: handleMenuSelect
              }
            ) : null
          }
        ) }),
        showMenuSidebar && /* @__PURE__ */ jsxs(
          Sider,
          {
            className: "left-tree-sider",
            style: {
              position: "sticky",
              top: headerHeight,
              alignSelf: "flex-start",
              height: `calc(100vh - ${headerHeight}px)`,
              overflowY: "auto",
              background: token.colorBgContainer,
              borderRadius: 0,
              padding: 0,
              boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.05), 0 16px 24px 0 rgba(0, 0, 0, 0.05)"
            },
            width: 304,
            children: [
              /* @__PURE__ */ jsx(
                "div",
                {
                  style: {
                    padding: "16px 16px 12px 16px",
                    display: "none"
                  },
                  className: "search-wrapper",
                  children: /* @__PURE__ */ jsx(
                    Input,
                    {
                      prefix: /* @__PURE__ */ jsx(Search, { className: "stroke-base" }),
                      onChange: handleTermChange,
                      allowClear: true
                    }
                  )
                }
              ),
              filteredItems.length ? /* @__PURE__ */ jsx(
                Menu,
                {
                  ref: menuRef,
                  className: "left-tree-menu",
                  mode: "inline",
                  defaultOpenKeys: openKeys,
                  selectedKeys,
                  items: filteredItems,
                  onClick: handleMenuSelect
                }
              ) : null
            ]
          }
        ),
        /* @__PURE__ */ jsx(
          Flex,
          {
            className: `container ${containerClassName}`,
            style: __spreadValues({
              minWidth: 0
            }, showMenuSidebar && {
              paddingTop: SIDEBAR_OFFSET,
              paddingBottom: SIDEBAR_OFFSET
            }),
            children: /* @__PURE__ */ jsxs(
              Layout,
              {
                className: "ant-layout-has-sider",
                style: {
                  background: "transparent",
                  gap: 24,
                  width: "100%",
                  position: "relative"
                },
                children: [
                  /* @__PURE__ */ jsx(Content, { children: /* @__PURE__ */ jsx(Outlet, {}) }),
                  !hideMenuSidebar && rightSidebar
                ]
              }
            )
          }
        )
      ] })
    }
  );
};
var stdin_default = memo(AppLayout);
export {
  stdin_default as default
};
